<app-page-content *ngIf="test" [narrow]="true">

  <mat-menu #testMenu="matMenu">
    <button mat-menu-item
            *ngIf="canEdit"
            (click)="openTestRenameDialog()">
      <mat-icon>mode_edit</mat-icon>
      <span>Переименовать</span>
    </button>
    <button mat-menu-item
            *ngIf="canActivate"
            (click)="openTestActivateDialog()">
      <mat-icon>check</mat-icon>
      <span>Активировать</span>
    </button>
    <button mat-menu-item
            *ngIf="canDeactivate"
            (click)="openTestDeactivateDialog()">
      <mat-icon>cancel</mat-icon>
      <span>Деактивировать</span>
    </button>
    <button mat-menu-item
            *ngIf="canDelete"
            (click)="openTestDeleteDialog()">
      <mat-icon>delete</mat-icon>
      <span>Удалить тест</span>
    </button>
  </mat-menu>
  <app-page-bar>
    <app-bar-back-button [link]="['/tests']"
                         [tooltip]="'Тесты'"></app-bar-back-button>
    <app-bar-title>{{test ? test.name : 'Тест'}}</app-bar-title>
    <app-bar-more-button [matMenuTriggerFor]="testMenu"></app-bar-more-button>
  </app-page-bar>
  <div class="description">
    <app-text-editor [label]="'Описание'"
                     [readonly]="!canEdit"
                     [noValue]="'Укажите описание'"
                     [value]="test.description"
                     [validators]="TEST_VALIDATORS.DESCRIPTION"
                     (valueChangeEvent)="onTestDescriptionChange($event)"
                     [multiline]="true"
                     [rows]="2">
      <span class="text">{{test.description}}</span>
    </app-text-editor>
  </div>

  <!-- Секция для баннера -->
  <div class="banner-section">
    <h3>Баннер</h3>
    <div class="banner-upload">
      <!-- Всегда рендерим input, но скрываем его -->
      <input #fileInput 
             type="file" 
             accept="image/*" 
             (change)="onFileSelected($event)" 
             style="display: none;">
      <!-- Предпросмотр текущего баннера с возможностью замены -->
      <div *ngIf="test.bannerUrl" class="banner-preview">
        <img [src]="test.bannerUrl" 
             alt="Banner Preview" 
             style="max-width: 100%; height: auto;" 
             [style.cursor]="canEditBanner ? 'pointer' : 'default'" 
             (click)="triggerFileInput()"
             title="Нажмите, чтобы заменить баннер">
      </div>
      <!-- Кнопка для загрузки, если баннера нет -->
      <div *ngIf="!test.bannerUrl && canEditBanner" class="banner-form">
        <button mat-raised-button 
                color="primary" 
                (click)="triggerFileInput()">
          Загрузить баннер
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="value-container">
      <div class="label">Продолжительность</div>
      <div class="value">
        <app-duration-editor label="'Продолжительность'"
                             [readonly]="!canEdit"
                             [value]="test.maxDuration"
                             (valueChangeEvent)="onTestDurationChange($event)"></app-duration-editor>
      </div>
    </div>
    <div class="value-container">
      <div class="label">Состояние</div>
      <div class="value">{{test.activateDate ? 'Активен' : 'Не активен'}}</div>
    </div>
  </div>

  <div class="summaries-container" *ngIf="testSummary">
    <a class="summary" [routerLink]="['/tests/', testSummary.id, 'results']">
      <div class="number">{{testSummary.resultsNumber}}</div>
      <div class="title">Результаты</div>
    </a>
    <a class="summary" [routerLink]="['/tests/', testSummary.id, 'questions']">
      <div class="number">{{testSummary.questionsNumber}}</div>
      <div class="title">Вопросы</div>
    </a>
  </div>

  <div class="actions">
    <button *ngIf="canActivate"
            mat-raised-button color="primary"
            (click)="openTestActivateDialog()">Активировать
    </button>
    <button *ngIf="canDeactivate"
            mat-raised-button color="warn"
            (click)="openTestDeactivateDialog()">Деактивировать
    </button>
  </div>

  <app-test-links-editor *ngIf="testLinks"
                         [testId]="test.id"
                         [testType]="test.type"
                         [testLinks]="testLinks"></app-test-links-editor>

</app-page-content>